// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"bba-z","subtitle":"cba-z","wrapper":"dba-z","leftArrow":"eba-z","rightArrow":"fba-z"};